export default {
	project_name: 'Academia Protecto',
	company_agency: 'Empresa / Loja',
	add_new_company: 'Adicionar nova empresa Empresa / Loja',
	no_company_agency_found: "Empresa / Loja no encontrada",
	state: 'Dpto/Prov/Est',
	regionals: 'País',
	profession: 'Perfil'
}
